import(/* webpackMode: "eager" */ "/lexoya/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/lexoya/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/lexoya/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/lexoya/src/components/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/lexoya/src/components/SetHtmlAttrs.tsx");
;
import(/* webpackMode: "eager" */ "/lexoya/src/components/SoundButton.tsx");
;
import(/* webpackMode: "eager" */ "/lexoya/src/components/WebMcpProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AudioProvider"] */ "/lexoya/src/context/AudioContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LangProvider"] */ "/lexoya/src/context/LangProvider.tsx");
